<script>
    export let selectedItem = null;
    let materials = selectedItem.materials ?? [];
    let headings = [
        "Description",
        "Part No.",
        "Quantity",
        "Unit Cost",
        "Total Cost",
        "",
    ];

    function addNewMaterial() {
        selectedItem.materials = [
            ...(selectedItem.materials ?? []),
            { material_description: "", part_no: "", unit_cost: 0.0, qty: 0.0 },
        ];
        materials = selectedItem.materials;
        return;
    }

    function removeMaterial(event) {
        const index = event.currentTarget.id;
        var existingMaterials = selectedItem.materials ?? [];
        if (existingMaterials.length > index) {
            existingMaterials.splice(index, 1);
            selectedItem.materials = existingMaterials;
            materials = existingMaterials;
        }
    }

    function changedMaterialValue(event, key) {
        const index = event.currentTarget.id;
        var existingMaterials = selectedItem.materials ?? [];
        if (existingMaterials.length > index) {
            if (["material_description", "part_no"].includes(key)) {
                existingMaterials[index][key] = event.currentTarget.value;
            } else if (["unit_cost", "qty"].includes(key)) {
                const value = Number(event.currentTarget.value);
                existingMaterials[index][key] = (isNaN(value)) ? 0.0 : value;
            }
            selectedItem.materials = existingMaterials;
            materials = existingMaterials;
        }
    }
</script>

<div class="edit-container">
    <div class="edit-section-title">Materials</div>
    {#if materials.length == 0}
        <p class="edit-related-statement">
            {"There are no materials listed for " + selectedItem.name ?? selectedItem.wpn2_type + "."}
        </p>
    {:else}
        <table class="general-table">
            <thead>
                <tr>
                    {#each headings as x}
                        <th scope="col">{x}</th>
                    {/each}
                </tr>
            </thead>
            <tbody>
                {#each materials as x, index}
                    <tr>
                        <td>
                            <input
                                class="material-input"
                                placeholder=""
                                type="text"
                                id={index}
                                value={x.material_description}
                                on:change|preventDefault={(event) =>
                                    changedMaterialValue(
                                        event,
                                        "material_description"
                                    )}
                            />
                        </td>
                        <td>
                            <input
                                class="material-input"
                                placeholder=""
                                type="text"
                                id={index}
                                value={x.part_no}
                                on:change|preventDefault={(event) =>
                                    changedMaterialValue(event, "part_no")}
                            />
                        </td>
                        <td>
                            <input
                                class="material-input"
                                type="number"
                                min="0"
                                step="1"
                                id={index}
                                value={x.qty}
                                on:change|preventDefault={(event) =>
                                    changedMaterialValue(event, "qty")}
                            />
                        </td>
                        <td>
                            <input
                                class="material-input"
                                type="number"
                                min="0"
                                step="0.01"
                                id={index}
                                value={x.unit_cost}
                                on:change|preventDefault={(event) =>
                                    changedMaterialValue(event, "unit_cost")}
                            />
                        </td>
                        <td
                            >{(x.qty ?? 0.0) *
                                (x.unit_cost ?? 0.0).toFixed(2)}</td
                        >
                        <td>
                            <button
                                class="trash-can-button"
                                id={index}
                                on:click|preventDefault={(event) =>
                                    removeMaterial(event)}
                            >
                                &#x1F5D1
                            </button>
                        </td>
                    </tr>
                {/each}
            </tbody>
        </table>
    {/if}
    <div class="add-button-view">
        <button class="edit-add-button" on:click={addNewMaterial}>
            Add Material
        </button>
    </div>
</div>

<style>
    .material-input {
        margin: 0;
    }
</style>
